/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_LogisticsInputs */

const en_nav_section_logistics = /** @type {(inputs: Nav_Section_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics`)
};

/**
* | output |
* | --- |
* | "Logistics" |
*
* @param {Nav_Section_LogisticsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_logistics = /** @type {((inputs?: Nav_Section_LogisticsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_LogisticsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_logistics(inputs)
});